import { render, staticRenderFns } from "./IssueRecord.vue?vue&type=template&id=5ed4799c&scoped=true"
import script from "./IssueRecord.vue?vue&type=script&lang=js"
export * from "./IssueRecord.vue?vue&type=script&lang=js"
import style0 from "./IssueRecord.vue?vue&type=style&index=0&id=5ed4799c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed4799c",
  null
  
)

export default component.exports